export default __webpack_public_path__ + "assets/card-logo-visa-component.fcf79412.svg";